import script from "./PalavrasChaveInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PalavrasChaveInput.vue?vue&type=script&setup=true&lang=js"

import "./PalavrasChaveInput.vue?vue&type=style&index=0&id=538da5e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538da5e1"]])

export default __exports__